// Editorial numerology archetypes — original copy for the Life Path preview.

export const LIFE_PATHS = {
  1: {
    archetype: "The Pioneer",
    overview:
      "You are here to lead, to begin, to walk paths others have not yet imagined. Independent and quietly determined, you carry an inner fire that asks you to trust your own direction.",
    strengths: ["Original vision", "Courageous initiative", "Self-reliance", "Quiet leadership"],
    growth: ["Softening into collaboration", "Patience with stillness", "Receiving support"],
  },
  2: {
    archetype: "The Harmoniser",
    overview:
      "Yours is the gift of connection. You sense the unspoken, hold space with grace, and bring people gently into balance. Peace is not passive for you — it is a craft.",
    strengths: ["Deep empathy", "Diplomacy", "Intuitive listening", "Devotion"],
    growth: ["Honouring your own needs", "Setting boundaries", "Trusting your voice"],
  },
  3: {
    archetype: "The Expressor",
    overview:
      "Creativity moves through you like breath. Words, colour, sound and joy are your native tongue — you remind others that life is meant to be felt and shared.",
    strengths: ["Creative expression", "Warmth", "Optimism", "Inspiring presence"],
    growth: ["Focus and follow-through", "Depth beneath the sparkle", "Emotional honesty"],
  },
  4: {
    archetype: "The Builder",
    overview:
      "You turn dreams into foundations. Grounded, loyal and patient, you create structures that last — a steady hand in a world that moves too quickly.",
    strengths: ["Discipline", "Reliability", "Practical wisdom", "Endurance"],
    growth: ["Flexibility", "Rest without guilt", "Openness to change"],
  },
  5: {
    archetype: "The Free Spirit",
    overview:
      "Freedom is your medicine. Curious and magnetic, you are here to taste experience fully — to move, to explore, and to teach others how to embrace change.",
    strengths: ["Adaptability", "Magnetism", "Courageous curiosity", "Vitality"],
    growth: ["Rooting yourself", "Commitment", "Stillness as freedom"],
  },
  6: {
    archetype: "The Nurturer",
    overview:
      "You carry a healing warmth. Home, harmony and care flow naturally from you — you hold others as you learn, gently, to hold yourself with the same tenderness.",
    strengths: ["Compassion", "Responsibility", "Devoted love", "Creating beauty"],
    growth: ["Releasing perfectionism", "Allowing yourself to be cared for", "Boundaries"],
  },
  7: {
    archetype: "The Seeker",
    overview:
      "Yours is the path of the inner world. Contemplative and perceptive, you seek the truth beneath the surface — a quiet mystic drawn to meaning, silence and depth.",
    strengths: ["Insight", "Intuition", "Analytical depth", "Spiritual awareness"],
    growth: ["Trusting others", "Sharing your inner world", "Warmth over isolation"],
  },
  8: {
    archetype: "The Visionary of Abundance",
    overview:
      "You understand power as responsibility. Ambitious and capable, you are here to manifest — to align material mastery with a deeper sense of integrity and purpose.",
    strengths: ["Leadership", "Resilience", "Strategic vision", "Manifestation"],
    growth: ["Balancing drive with rest", "Vulnerability", "Wealth beyond the material"],
  },
  9: {
    archetype: "The Humanitarian",
    overview:
      "You feel the whole of the world. Compassionate and wise beyond your years, you are here to give, to release, and to remind humanity of its shared heart.",
    strengths: ["Compassion", "Wisdom", "Generosity", "Artistic soul"],
    growth: ["Letting go with grace", "Receiving as freely as you give", "Self-compassion"],
  },
  11: {
    archetype: "The Illuminator",
    overview:
      "A master vibration. You are a channel of intuition and inspiration — sensitive, visionary, and here to illuminate the path for others through your own inner light.",
    strengths: ["Heightened intuition", "Inspiration", "Spiritual insight", "Sensitivity"],
    growth: ["Grounding your energy", "Managing sensitivity", "Trusting your calling"],
  },
  22: {
    archetype: "The Master Builder",
    overview:
      "The most powerful of vibrations. You hold the vision of the dreamer and the discipline of the builder — able to turn the highest ideals into lasting reality.",
    strengths: ["Visionary practicality", "Leadership", "Endurance", "Manifesting at scale"],
    growth: ["Trusting your own capacity", "Balance", "Patience with the process"],
  },
  33: {
    archetype: "The Master Teacher",
    overview:
      "The vibration of compassionate service. You are here to uplift through love and wisdom — a nurturing guide whose presence itself becomes a form of healing.",
    strengths: ["Selfless love", "Healing presence", "Wisdom", "Devotion to others"],
    growth: ["Avoiding self-sacrifice", "Honouring your limits", "Grounded compassion"],
  },
};

export const PREMIUM_INSIGHTS = [
  {
    title: "Hidden Numbers",
    teaser: "The subtle vibrations beneath the surface — the karmic and destiny numbers quietly shaping your inner world.",
  },
  {
    title: "Personal Year",
    teaser: "The energetic season you are moving through now, and the invitation it carries for the months ahead.",
  },
  {
    title: "Career Guidance",
    teaser: "The vocations and rhythms of work where your particular frequency is most likely to flourish.",
  },
  {
    title: "Relationship Compatibility",
    teaser: "The numerical harmony between you and those you love, work with, and are drawn toward.",
  },
  {
    title: "Name Harmony",
    teaser: "How the full sound and structure of your name resonate with your soul's deeper intention.",
  },
];
